import PIXI from 'pixi.js/src';
import config from './../config/config';
import renderHelper from './../helpers/render';
import highScorePopupView from './high-score-view';
import GameStore from './../stores/GameStore';
import router from './../router/router';
import AppDispatcher from './../dispatcher/AppDispatcher';
import AppConstants from './../constants/AppConstants';
import 'whatwg-fetch';

const leaderboardView = {
  highShotScores: [],
  highPercentageScores: [],
  newHighShotScore: false,
  textItems: [],
  scoreItems: [],
  contentWidth: 250,


  /**
   * Sets up the view
   * @param {Number} level - The current level
   * @param {Boolean} skipComparison - Whether to skip checking
   * if the user beat a high score
   * @returns {undefined} undefined
   */
  init(skipComparison) {
    this.skipComparison = skipComparison;
    this.graphicsContainer = new PIXI.Container();
    renderHelper.stage.addChild(this.graphicsContainer);
    this.getHighScores();

    this.titleText = new PIXI.Text('LEADERBOARD',
      {
        font: '24px ' + config.fontName,
        fill: config.whiteColor,
      }
    );
    this.titleText.resolution = 2;
    this.graphicsContainer.addChild(this.titleText);
    this.titleText.x = Math.round((this.contentWidth / 2) -
      (this.titleText.width / 2));
    this.titleText.y = 20;

    this.replayButton = new PIXI.Text('PLAY AGAIN >',
      {
        font: '24px ' + config.fontName,
        fill: config.whiteColor,
      }
    );
    this.replayButton.resolution = 2;
    renderHelper.stage.addChild(this.replayButton);
    this.replayButton.interactive = true;
    this.replayButton.on('touchstart', this.onButtonClick);
    this.replayButton.on('mousedown', this.onButtonClick);

    this.resizeListener = this.onResize.bind(this);
    window.addEventListener('resize', this.resizeListener);
    window.addEventListener('orientationchange', this.resizeListener);

    this.positionGraphics();
  },


  /**
   * Click handler for the replay button
   * @returns {undefined} undefined
   */
  onButtonClick() {
    AppDispatcher.handleViewAction({
      actionType: AppConstants.RESET,
    });

    setTimeout(() => {
      router.navigate('start');
    }, 10);
  },


  /**
   * Orientation change handler
   * @returns {undefined} undefined
   */
  onResize() {
    this.positionGraphics();
  },


  /**
   * Positions graphics
   * @returns {undefined} undefined
   */
  positionGraphics() {
    this.graphicsContainer.x = (window.innerWidth / 2) - (this.contentWidth / 2);

    this.replayButton.x = (window.innerWidth / 2) - (this.replayButton.width / 2);
    this.replayButton.y = window.innerHeight - this.replayButton.height - 40;
  },


  /**
   * Gets high scores from the API
   * @returns {undefined} undefined
   */
  getHighScores() {
    const _this = this;

    this.highShotScores = [];
    this.highPercentageScores = [];
    this.apiDataCount = 0;
    this.newHighShotScore = false;
    this.newHighPercentageScore = false;

    // Get highest shots made scores
    fetch(config.apiEndpoint + 'high_scores?sort=shots_made', {
      method: 'get',
    }).then((response) => {
      return response.json();
    }).then((json) => {
      _this.highShotScores = json;
      _this.displayScores();
      if (!_this.skipComparison) {
        _this.compareScores();
      }
    }).catch((ex) => {
      console.log('high shots made scores parsing failed', ex);
    });
  },


  /**
   * Displays the high scores in the leaderboard
   * @returns {undefined} undefined
   */
  displayScores() {
    this.removeScores();
    this.textItems = [];

    for (let i = 0; i < this.highShotScores.length; i++) {
      const scoreText =
        new PIXI.Text((i + 1) + '. ' + this.highShotScores[i].name.toUpperCase(),
          {
            font: '18px ' + config.fontName,
            fill: config.whiteColor,
          }
        );

      scoreText.resolution = 2;
      scoreText.y = 80 + (i * 20);
      this.graphicsContainer.addChild(scoreText);
      this.textItems.push(scoreText);

      const madeText =
        new PIXI.Text(this.highShotScores[i].shots_made,
          {
            font: '18px ' + config.fontName,
            fill: config.whiteColor,
          }
        );

      madeText.resolution = 2;
      this.graphicsContainer.addChild(madeText);
      madeText.x = this.contentWidth - madeText.width;
      madeText.y = 80 + (i * 25);
      this.scoreItems.push(madeText);
    }
  },


  /**
   * Removes all scores
   * @returns {undefined} undefined
   */
  removeScores() {
    for (let i = 0; i < this.textItems.length; i++) {
      this.graphicsContainer.removeChild(this.textItems[i]);
    }
  },


  /**
   * Compares the user's scores with the high scores
   * @returns {undefined} undefined
   */
  compareScores() {
    const state = GameStore.getState();
    const shotPercentage = (state.totalMadeShots / state.totalBaskets) * 100;

    if (this.highShotScores.length >= 10) {
      for (let i = 0; i < this.highShotScores.length; i++) {
        if (state.totalScore > this.highShotScores[i].shots_made) {
          this.newHighShotScore = true;
          break;
        }
      }
    } else {
      this.newHighShotScore = true;
    }

    if (this.newHighShotScore) {
      this.showPopup(state.totalScore, shotPercentage);
    }
  },


  /**
   * Shows a prompt to enter info if a record was broken
   * @param {Number} totalMadeShots - The user's total amount of made shots
   * @param {Number} shotPercentage - The user's shot percentage
   * @returns {undefined} undefined
   */
  showPopup(totalMadeShots, shotPercentage) {
    highScorePopupView.show(totalMadeShots, shotPercentage);
  },


  /**
   * Destroys the view
   * @returns {undefined} undefined
   */
  destroy() {
    renderHelper.stage.removeChild(this.graphicsContainer);
    renderHelper.stage.removeChild(this.replayButton);
  },
};

export default leaderboardView;



/** WEBPACK FOOTER **
 ** ./assets/js/src/views/leaderboard.js
 **/